import { RoutingDirection } from '~/src/models/leads'
import * as Sentry from '@sentry/browser'
import CookiesUtil from '~/src/utils/cookies'
import { debug } from '~/src/utils/debugLog'

function getIsFirstAppLovinSubmission() {
  const rampWebId = getRampWebId()
  try {
    return localStorage.getItem('axon_email_submission') !== rampWebId
  } catch (err) {
    return true
  }
}

function setFirstAppLovinSubmission() {
  const rampWebId = getRampWebId()
  localStorage.setItem('axon_email_submission', rampWebId)
}

function getIsRoutingDirectionHighEnough(routingDirection: RoutingDirection) {
  return (
    routingDirection === RoutingDirection.SALES_QUALIFIED ||
    routingDirection === RoutingDirection.SALES_OPTIONAL ||
    routingDirection === RoutingDirection.SELF_SERVICE_NO_PREQUAL
  )
}

function getRampWebId() {
  return CookiesUtil.get('ramp_web_id')
}

function getIsSubmissionFromAppLovin() {
  const utmSource = CookiesUtil.get('utm_source')
  const initialUtmSource = CookiesUtil.get('initial_utm_source')

  return (
    (typeof utmSource === 'string' && utmSource.toLowerCase() === 'applovin') ||
    (typeof initialUtmSource === 'string' && initialUtmSource.toLowerCase() === 'applovin')
  )
}

export function trackAppLovinLead(routingDirection: RoutingDirection) {
  debug.log('trackAppLovinLead', routingDirection)
  // Is the submission from AppLovin?
  const isSubmissionFromAppLovin = getIsSubmissionFromAppLovin()
  if (!isSubmissionFromAppLovin) {
    return
  }

  debug.log('isSubmissionFromAppLovin', isSubmissionFromAppLovin)
  // Is this the first AppLovin submission?
  const isFirstAppLovinSubmission = getIsFirstAppLovinSubmission()
  if (!isFirstAppLovinSubmission) {
    return
  }

  debug.log('isFirstAppLovinSubmission', isFirstAppLovinSubmission)
  // Is the lead score above SELF_SERVICE_PREQUAL?
  const isRoutingDirectionHighEnough = getIsRoutingDirectionHighEnough(routingDirection)
  if (!isRoutingDirectionHighEnough) {
    return
  }

  debug.log('isRoutingDirectionHighEnough', isRoutingDirectionHighEnough)
  // Do we have a ramp_web_id cookie?
  // We should always have one if the user came from ramp.com, but we'll check just in case
  const rampWebId = getRampWebId()
  if (!rampWebId) {
    console.warn('ramp_web_id cookie is not set')
    Sentry.captureMessage('ramp_web_id cookie is not set', {
      level: 'warning',
    })
    return
  }

  debug.log('rampWebId', rampWebId)

  // Did Google Tag Manager properly load the axon tag into the window object?
  // This may fail if the user blocks tracking
  if (!window.axon) {
    debug.log('axon is not defined')
    Sentry.captureMessage('AppLovin lead tracking failed because axon is not defined', {
      level: 'log',
    })
    return
  }

  window.axon('track', 'generate_lead', {
    user_id: rampWebId,
  })

  setFirstAppLovinSubmission()
}
